import { Athletes } from "../athletes"
import { Calendar } from "../calendar"
import { useMeContext } from "../../model/user/provider"
import { SharedLinkHandoff } from "@/features/calendar/components/trainings/sharedLinkHandoff"
import { TRAININGS_PAGE } from "@shared/constants/navigation"

export function MainPage() {
  const { currentRole } = useMeContext()

  // A coach's home is the athletes list, which opens neither a workout nor a plan — a link
  // shared by an athlete moves on to the coach's own calendar page.
  return currentRole.isCoach ? (
    <SharedLinkHandoff to={TRAININGS_PAGE}>
      <Athletes />
    </SharedLinkHandoff>
  ) : (
    <Calendar />
  )
}
